import { createSelector } from 'reselect';

const selectRoot = (state) => state.connectCards;

const selectById = (state, hash) => {
  const { data, loading } = state;
  return {
    data: data[hash],
    loading,
  };
};

export const selectConnectCard = (id) =>
  createSelector([selectRoot], (root) => selectById(root, id));
